import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWalkNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.33 17.33H5.67v1.34h2.66zm4 0H9.67v1.34h2.66zm4 0h-2.66v1.34h2.66z" />
        <path d="M20.76 11.33h-2.01l-6.89-3.67-1.22-2.29a1.978 1.978 0 00-3.72.93v.95l-1 1.88a.425.425 0 01-.71.01l-.4-.72A2.023 2.023 0 003 7.33H1.33v7.1l-.31.29a2.32 2.32 0 00-.69 1.67 2.279 2.279 0 002.28 2.28h1.72v-1.34H2.61a.94.94 0 01-.94-.94.973.973 0 01.29-.7l.04-.04v.02h10.33v-1.34H2.67V8.67H3a.7.7 0 01.62.39l.42.75a1.755 1.755 0 003.07-.05l1.16-2.17V6.3a.64.64 0 01.63-.63.622.622 0 01.55.34l1.41 2.65.69.37-.78 1.46 1.2.64.78-1.47 1.29.69-.78 1.47 1.19.64.78-1.48 1.28.68-.78 1.48 1.19.64.79-1.48.7.37h2.35a1.579 1.579 0 011.57 1.57 1.664 1.664 0 01-.49 1.18 6.742 6.742 0 01-4.17 1.88v1.34a8.093 8.093 0 005.12-2.26 3.002 3.002 0 00.66-3.254 2.905 2.905 0 00-2.69-1.796z" />
      </g>
    </svg>
  )
);
SvgSportsWalkNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsWalkNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWalkNormalSmall;
